if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { useState } = window.wp.element;

    const {
        InspectorControls,
        MediaUpload,
        InnerBlocks
    } = window.wp.editor;

    const {
        PanelBody,
        Button,
        TextControl,
        SelectControl,
        CheckboxControl
    } = window.wp.components;

    function renderHeroBackground(attributes, legacyControls = false) {
        if (!legacyControls && attributes.backgroundType === 'video' && attributes.video) {
            return (
                <div className="img hero-video cover-image lozad bg-dark" data-background-image={ attributes.image || attributes.mobileImage || undefined } data-background-image-desktop={ attributes.mobileImage ? attributes.image || attributes.mobileImage : undefined } data-background-image-mobile={ attributes.mobileImage || undefined } aria-hidden="true">
                    <video className="background-video" data-hero-video={ attributes.video } muted loop playsInline preload="none" tabIndex="-1"></video>
                </div>
            );
        }
        const images = [
            ...(attributes.image ? [{ url: attributes.image, alt: attributes.alt }] : []),
            ...(attributes.sliderImages || [])
        ].filter((image, index, list) => list.findIndex(item => item.url === image.url) === index);
        const slider = images.length > 1;

        function renderImage(image, index) {
            const mobileImage = index === 0 ? attributes.mobileImage : '';
            return (
                <div
                    key={ image.url }
                    className={ 'img cover-image lozad bg-dark' + (slider && index === 0 ? ' is-active' : '') }
                    data-background-image={ image.url || mobileImage || undefined }
                    data-background-image-desktop={ mobileImage ? image.url || mobileImage : undefined }
                    data-background-image-mobile={ mobileImage || undefined }
                    role={ image.alt ? 'img' : undefined }
                    aria-label={ image.alt || undefined }
                    aria-hidden={ image.alt ? undefined : true }
                ></div>
            );
        }

        if (!slider) return renderImage(images[0] || { url: attributes.mobileImage || '', alt: attributes.alt }, 0);
        return (
            <div className="hero-photo-slider" aria-label="Hero slideshow">
                { images.map(renderImage) }
                { legacyControls && <div className="hero-slider-controls">
                    <button type="button" data-hero-direction="prev" aria-label="Previous image"><i className="las la-angle-left" aria-hidden="true"></i></button>
                    <button type="button" data-hero-direction="next" aria-label="Next image"><i className="las la-angle-right" aria-hidden="true"></i></button>
                </div> }
            </div>
        );
    }

    registerBlockType('custom-gutenberg/hero-bg-image', {
        // built-in attributes
        title: 'Hero Background Image',
        description: 'Hero section with a background image and editable text.',
        icon: 'format-image',
        category: 'custom-content',
        example: {},

        // custom attributes
        attributes: {
            backgroundType: { type: 'string', default: 'image' },
            video: { type: 'string', default: '' },
            videoId: { type: 'number', default: 0 },
            sliderImages: {
                type: 'array',
                default: []
            },
            compactHeight: {
                type: 'boolean',
                default: false
            },
            mobileImage: {
                type: 'string',
                default: ''
            },
            mobileImageId: {
                type: 'number',
                default: 0
            },
            image: {
                type: 'string',
                default: ''
            },
            imageId: {
                type: 'number',
                default: 0
            },
            alt: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const { image, imageId, alt, mobileImage, mobileImageId } = attributes;
            const [preview, setPreview] = useState('desktop');
            const previewImage = preview === 'mobile' ? mobileImage || image : image;

            function onSelectImage(image) {
                const full = image.sizes && image.sizes.full;
                setAttributes({
                    image: full ? full.url : image.url,
                    imageId: image.id,
                    alt: image.alt || ''
                });
            }

            function onRemoveImage() {
                setAttributes({ image: '', imageId: 0, alt: '' });
            }

            function onSelectMobileImage(image) {
                const full = image.sizes && image.sizes.full;
                setAttributes({ mobileImage: full ? full.url : image.url, mobileImageId: image.id });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Background type">
                        <SelectControl label="Type" value={ attributes.backgroundType } options={ [{ label: 'Image / slider', value: 'image' }, { label: 'Video', value: 'video' }] } onChange={ backgroundType => setAttributes({ backgroundType: backgroundType }) } />
                    </PanelBody>
                    { attributes.backgroundType === 'video' && (
                        <PanelBody title="Background video">
                            <TextControl
                                label="Video URL"
                                type="url"
                                value={ attributes.video }
                                onChange={ video => setAttributes({ video: video.trim(), videoId: 0 }) }
                                help="Enter a direct video file URL (for example MP4), or select a video from the Media Library. YouTube and Vimeo page links are not supported."
                            />
                            <MediaUpload
                                type="video"
                                allowedTypes={ ['video'] }
                                value={ attributes.videoId }
                                onSelect={ video => setAttributes({ video: video.url, videoId: video.id }) }
                                render={ ({ open }) => <Button className="button" onClick={ open }>{ attributes.video ? 'Replace video' : 'Select video' }</Button> }
                            />
                            { attributes.video && <Button className="button" onClick={ () => setAttributes({ video: '', videoId: 0 }) }>Remove video</Button> }
                            <p>The main image is used as the poster and fallback.</p>
                        </PanelBody>
                    ) }
                    <PanelBody title="Hero slider">
                        <p>Select additional images to turn the background into a slideshow. The main image stays first.</p>
                        <MediaUpload
                            multiple
                            gallery
                            type="image"
                            allowedTypes={ ['image'] }
                            value={ attributes.sliderImages.map(image => image.id) }
                            onSelect={ images => setAttributes({ sliderImages: images.map(image => ({ id: image.id, url: image.sizes && image.sizes.full ? image.sizes.full.url : image.url, alt: image.alt || '' })) }) }
                            render={ ({ open }) => <Button className="button" onClick={ open }>Select slider images</Button> }
                        />
                        { attributes.sliderImages.length > 0 && <Button className="button" onClick={ () => setAttributes({ sliderImages: [] }) }>Remove slider images</Button> }
                    </PanelBody>
                    <PanelBody title="Hero settings">
                        <CheckboxControl
                            label="Manja visina"
                            checked={ attributes.compactHeight }
                            onChange={ compactHeight => setAttributes({ compactHeight: compactHeight }) }
                        />
                    </PanelBody>
                    <PanelBody title="Background image">
                        <MediaUpload
                            onSelect={ onSelectImage }
                            allowedTypes={ ['image'] }
                            type="image"
                            value={ imageId }
                            render={ ({ open }) => (
                                <div>
                                    { image && <figure><img src={ image } alt={ alt } /></figure> }
                                    <Button onClick={ open } className="button">
                                        { image ? 'Replace image' : 'Select image' }
                                    </Button>
                                    { image && <Button onClick={ onRemoveImage } className="button">Remove image</Button> }
                                </div>
                            ) }
                        />
                        <TextControl
                            label="Image description"
                            value={ alt }
                            onChange={ alt => setAttributes({ alt: alt }) }
                        />
                    </PanelBody>
                    <PanelBody title="Mobile background image">
                        <p>If no mobile image is selected, the main image is used.</p>
                        <MediaUpload
                            onSelect={ onSelectMobileImage }
                            allowedTypes={ ['image'] }
                            type="image"
                            value={ mobileImageId }
                            render={ ({ open }) => (
                                <div>
                                    { mobileImage && <figure><img src={ mobileImage } alt={ alt } /></figure> }
                                    <Button onClick={ open } className="button">
                                        { mobileImage ? 'Replace image' : 'Select image' }
                                    </Button>
                                    { mobileImage && <Button onClick={ () => setAttributes({ mobileImage: '', mobileImageId: 0 }) } className="button">Remove image</Button> }
                                </div>
                            ) }
                        />
                        <SelectControl
                            label="Image preview"
                            value={ preview }
                            options={ [{ label: 'Desktop', value: 'desktop' }, { label: 'Mobile', value: 'mobile' }] }
                            onChange={ setPreview }
                        />
                    </PanelBody>
                </InspectorControls>,
                <section key="preview" className={ 'home-hero hero-editor-preview' + (attributes.compactHeight ? ' landing-hero' : '') }>
                    <div className={ 'img cover-image bg-dark' + (attributes.backgroundType === 'video' && attributes.video ? ' hero-video' : '') } style={ { backgroundImage: previewImage ? `url(${previewImage})` : undefined } }>
                        { attributes.backgroundType === 'video' && attributes.video && <video className="background-video is-playing" src={ attributes.video } poster={ previewImage || undefined } controls muted playsInline preload="metadata"></video> }
                    </div>
                    <div className="home-hero-content">
                        <InnerBlocks
                            templateLock={ false }
                            renderAppender={ InnerBlocks.ButtonBlockAppender }
                        />
                    </div>
                </section>
            ]);
        },

        save({ attributes }) {

            const { image, alt, mobileImage } = attributes;
            const hasImage = image || mobileImage;

            return (
                <section className={ 'home-hero' + (attributes.compactHeight ? ' landing-hero' : '') }>
                    { renderHeroBackground(attributes) }
                    <InnerBlocks.Content />
                </section>
            );
        },

        // Keep previously saved hero content valid without deleting its blocks.
        deprecated: [{
            attributes: {
                image: { type: 'string', default: '' },
                imageId: { type: 'number', default: 0 },
                alt: { type: 'string', default: '' },
                mobileImage: { type: 'string', default: '' },
                mobileImageId: { type: 'number', default: 0 },
                compactHeight: { type: 'boolean', default: false },
                sliderImages: { type: 'array', default: [] }
            },
            save({ attributes }) {
                return (
                    <section className={ 'home-hero' + (attributes.compactHeight ? ' landing-hero' : '') }>
                        { renderHeroBackground(attributes, true) }
                        <InnerBlocks.Content />
                    </section>
                );
            }
        }, {
            attributes: {
                image: { type: 'string', default: '' },
                imageId: { type: 'number', default: 0 },
                alt: { type: 'string', default: '' },
                mobileImage: { type: 'string', default: '' },
                mobileImageId: { type: 'number', default: 0 }
            },
            save({ attributes }) {
                const { image, alt, mobileImage } = attributes;
                const hasImage = image || mobileImage;

                return (
                    <section className="home-hero">
                        <div
                            className="img cover-image lozad bg-dark"
                            data-background-image={ image || mobileImage || undefined }
                            data-background-image-desktop={ mobileImage ? image || mobileImage : undefined }
                            data-background-image-mobile={ mobileImage || undefined }
                            role={ hasImage && alt ? 'img' : undefined }
                            aria-label={ hasImage && alt ? alt : undefined }
                            aria-hidden={ hasImage && alt ? undefined : true }
                        ></div>
                        <div className="container home-hero-content">
                            <InnerBlocks.Content />
                        </div>
                    </section>
                );
            }
        }]
    });
}
